module.exports = __webpack_public_path__ + "static/media/36-11.aab59da3.mp3";